import { observer } from "mobx-react";
import styles from "./styles/NavigationSecondary.module.scss";
import classNames from "classnames";
import MegaNav from "./navigation/meganav/MegaNav";
import { useFloatingBlocksThemeLayout } from "../../hooks/useFloatingBlocksThemeLayout";
import { useTranslateClassName } from "../../hooks/useTranslateClassName";
import { useStores } from "../../stores/useStores";
import { useShouldDisplayHero } from "../../hooks/useShouldDisplayHero";
import { useGridType } from "../../hooks/useGridType";
import { GridTypes } from "../../utils/SchoolBlocksUtilities";

export function useSecondaryNavIsSticky() {
  const { organizationStore } = useStores();
  const displayHero = useShouldDisplayHero();
  const gridType = useGridType();

  const stickySecondaryNav =
    organizationStore.currentOrganization.json_data.settings?.appearance
      ?.stickySecondaryNav;

  // When stickySecondaryNav has been defined, respect that value. Otherwise, maintain backwards compatibility with only sticky sub nav for subpages
  return (
    (stickySecondaryNav ??
      organizationStore.organization.id !==
        organizationStore.currentOrganization.id) &&
    gridType === GridTypes.terraced &&
    displayHero
  );
}

const NavigationSecondary = observer(
  (props: {
    isWelcomePage: boolean;
    visible: boolean;
    heroIsEnabled: boolean;
  }) => {
    const floatingBlocksThemeLayout = useFloatingBlocksThemeLayout();
    const translateClassName = useTranslateClassName();
    const stickyNavigation = useSecondaryNavIsSticky();

    const secondaryClassName = classNames({
      [styles.secondary]: true,
      [styles.secondaryFloatingBlocks]: floatingBlocksThemeLayout,
      [styles.secondaryIsSticky]: stickyNavigation,
      [styles.secondaryVisible]: props.visible,
      [translateClassName]: true,
      ["sb-secondary-nav sb-organization-color-secondary-nav clearfix"]:
        !props.isWelcomePage,
      ["sb-navbar-secondary-container sb-content-width-plus-margin"]:
        !props.isWelcomePage && floatingBlocksThemeLayout,
    });

    return (
      <div className={secondaryClassName} id={"sb-secondary-nav"}>
        <MegaNav />
      </div>
    );
  },
);

export default NavigationSecondary;
